var map = {
	"./africa": 567,
	"./africa.js": 567,
	"./australia": 568,
	"./australia.js": 568,
	"./bangladesh": 569,
	"./bangladesh.js": 569,
	"./global": 570,
	"./global.js": 570,
	"./india": 571,
	"./india.js": 571,
	"./newzealand": 572,
	"./newzealand.js": 572,
	"./pakistan": 573,
	"./pakistan.js": 573,
	"./srilanka": 574,
	"./srilanka.js": 574,
	"./unitedkingdom": 575,
	"./unitedkingdom.js": 575,
	"./unitedstates": 576,
	"./unitedstates.js": 576
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config/cricinfo ^\.\/.*$
// module id = 566
// module chunks = 0